import React from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { Store } from "@/types";

interface StoreFilterProps {
  stores: Store[];
  selectedStore: string | null;
  onStoreChange: (storeId: string | null) => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

const StoreFilter: React.FC<StoreFilterProps> = ({ 
  stores, 
  selectedStore, 
  onStoreChange,
  searchQuery,
  onSearchChange
}) => {
  return (
    <div className="mb-4 flex flex-col md:flex-row gap-4">
      <div className="flex items-center gap-2 flex-1">
        <Label htmlFor="store-filter" className="flex-none whitespace-nowrap">Filtrar por loja:</Label>
        <Select 
          value={selectedStore || "all"} 
          onValueChange={(value) => onStoreChange(value === "all" ? null : value)}
        >
          <SelectTrigger id="store-filter" className="bg-brand-darker border-gray-600">
            <SelectValue placeholder="Todas as lojas" />
          </SelectTrigger>
          <SelectContent className="bg-brand-dark border-gray-700">
            <SelectItem value="all">Todas as lojas</SelectItem>
            {stores.map(store => (
              <SelectItem key={store.id} value={store.id}>{store.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      
      <div className="flex items-center gap-2 flex-1">
        <Label htmlFor="user-search" className="flex-none whitespace-nowrap">Pesquisar utilizadores:</Label>
        <div className="relative flex-1">
          <Search className="absolute left-2 top-2.5 h-4 w-4 text-gray-400" />
          <Input
            id="user-search"
            type="text"
            placeholder="Pesquisar por nome ou email"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-8 bg-brand-darker border-gray-600"
          />
        </div>
      </div>
    </div>
  );
};

export default StoreFilter;
